import styled from '@emotion/styled';
import React from 'react';

import { Dealer } from '../../gql/graphql';
import { useReportError } from '../../hooks/dtrum';
import InternalError from '../../pages/internalError/InternalError';
import { fontFamilies } from '../baseStyle/Variables';
import Header from '../header/Header';
import { SegmentProps } from '../../state-machine/actions/segment';
import { Role } from '../../types/role';
import { useTranslation } from 'react-i18next';

const ErrorWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: ${fontFamilies.gilroyRegular};
  justify-content: center;
  margin: 0 auto;
  padding: 0 2rem 2rem;
  width: 75%;
`;

type Props = SegmentProps & {
  orderId: string;
  dealer: Dealer | undefined;
  role: Role | undefined;
  error?: any;
  body?: string;
  additionalBody?: string;
  heading?: string;
  buttonText?: string;
};

const CustomErrorBoundary: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { error, body, additionalBody, buttonText, heading } = props;
  const reportErr = useReportError();

  if (error) {
    reportErr(error);
    console.error(error);
    console.error(error?.stack);
    console.trace();
  }

  const storeName = props.dealer?.storeName;

  props.page('ErrorBoundary', props.error);
  props.track('ErrorBoundary - something went wrong', { error, orderId: props.orderId }); // TODO: I removed the order from this, is that okay?
  return (
    <>
      <Header
        orderId={props.orderId}
        dealer={props.dealer}
        goBackFunc={undefined}
        currentNode={['CustomErrorBoundary']}
        track={props.track}
        page={props.page}
        identify={props.identify}
      />
      <ErrorWrapper id="ErrorBoundary">
        <InternalError
          orderId={props.orderId}
          dealer={props.dealer!}
          role={props.role!}
          heading={heading ? heading : ''}
          body={
            body
              ? body
              : t(($) => $.error.unexpected, {
                  storeName,
                })
          }
          additionalBody={additionalBody ? additionalBody : ''}
          buttonText={buttonText ? buttonText : ''}
          track={props.track}
          page={props.page}
          identify={props.identify}
        />
      </ErrorWrapper>
    </>
  );
};

export default CustomErrorBoundary;
